export const RECEIVED_MARKETS = 'RECEIVED_MARKETS';

const getMarkets = () => (
  (dispatch) => {
    dispatch({
      type: RECEIVED_MARKETS,
      markets: window.markets,
    });
  }
);

export default getMarkets;
